import * as React from "react";
import { ChatTile, Message, Chat } from "../../components";
import "./index.css";
import { supabase } from "../../app/supabaseClient";

const Messages = () => {

  const [messages, setMessages] = React.useState([]);

  React.useEffect(() => {
    fetchMessageData();
  }, []);

  const fetchMessageData = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    console.log("User:", user);
    if (!user) {
      console.log("User not logged in");
      return;
    }
    console.log("Fetching message data for user:", user.id);
    try {
      const { data, error } = await supabase
        .from("messages")
        .select("*, classifieds(title, description, properties)")
        .or(`owner_id.eq.${user.id},sender_id.eq.${user.id}`)
      if (error) throw error;
      setMessages(data);
    } catch (error) {
      console.error("Error fetching message data:", error);
    }
  };

  return (
    <section title={"Message group"} className="message-group container">
      {messages.map((message, i) => {
        console.log("Messages classified:", messages[i].classifieds);
        return (
          <ChatTile
            id={message.id}
            key={i}
            title={messages[i].classifieds?.title}
            description={messages[i].classifieds?.description}
            image={messages[i].classifieds?.properties?.images[0]}
            date={Date.now()}
            notificationCount={i}
            onClick={() => {
              console.log("Clicked");
            }}
          />
        );
      })}
    </section>
  );
};

export default Messages;
